import { CatTableRow } from '@blocks-react/components/TableRow';

import { ChildProps } from '../../types';

export const CVATableRow = ({ children }: Readonly<ChildProps>) => {
  return <CatTableRow>{children}</CatTableRow>;
};
